/**
 * Interface for the referring user from the API.
 * Based on actual API response shape.
 */
export interface ReferringUser {
  userId?: string;
  name?: string;
  type?: number;
  createdDate?: string;
}

/**
 * Mixin interface for items that can have referral information.
 * These properties come directly from the API response.
 */
export interface WithReferralInfo {
  referringId?: number;
  referringPracticeId?: number;
  referringUser?: ReferringUser;
  isReferred?: boolean;
}

/**
 * Helper function to check if an item has referral info
 */
export function hasReferralInfo(item: WithReferralInfo | undefined | null): boolean {
  if (!item) return false;
  return item.isReferred === true || !!(item.referringId || item.referringPracticeId);
}

/**
 * Helper function to format referral source display
 */
export function formatReferralSource(item?: WithReferralInfo): string {
  if (!item || !hasReferralInfo(item)) return '';

  const name = item.referringUser?.name?.trim();
  if (name && name.length > 0) {
    return `Referred by ${name}`;
  }

  return 'Referred';
}
